export default __webpack_public_path__ + "static/media/arrow_forward_black_-19.f1297a71.png";